import { Suspense } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import ScrollToTop from '../../components/base/ScrollToTop';
import { SEO } from '../../utils/seo';
import HeroSection from './components/HeroSection';
import IntroSection from './components/IntroSection';
import StaffSection from './components/StaffSection';
import NewsSection from './components/NewsSection';
import FaqSection from './components/FaqSection';
import CtaSection from './components/CtaSection';

const HomePage = () => {
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';
  
  const schema = {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    "name": "おかやま就労支援事業所",
    "description": "岡山市北区の就労支援事業所。障害や病気があっても自分らしく働きたい方を全力サポート。",
    "url": siteUrl,
    "telephone": "+81-86-012-3456",
    "faxNumber": "+81-86-012-3457",
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "○○町1-2-3",
      "addressLocality": "岡山市北区",
      "addressRegion": "岡山県",
      "addressCountry": "JP"
    },
    "geo": {
      "@type": "GeoCoordinates",
      "latitude": "34.6617",
      "longitude": "133.9350"
    },
    "openingHoursSpecification": {
      "@type": "OpeningHoursSpecification",
      "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
      "opens": "09:00",
      "closes": "18:00"
    },
    "founder": {
      "@type": "Person",
      "name": "岡山太郎"
    }
  };

  return (
    <Suspense fallback={<div>Loading...</div>}>
      <SEO
        title="岡山市の就労支援事業所｜障害者の自分らしい働き方をサポート｜おかやま就労支援事業所"
        description="岡山市北区の就労支援事業所。障害や病気があっても自分らしく働きたい方を全力サポート。個別支援計画、職業訓練、就職後フォローまで一貫支援。見学随時受付中。営業時間9:00-18:00、日祝休。TEL:086-012-3456"
        keywords="岡山市,就労支援,障害者雇用,就労継続支援,職業訓練,岡山北区"
        schema={schema}
      />
      <ScrollToTop />
      <div className="min-h-screen bg-bg-ivory">
        <Header />
        <main>
          <HeroSection />
          <IntroSection />
          <StaffSection />
          <NewsSection />
          <FaqSection />
          <CtaSection />
        </main>
        <Footer />
      </div>
    </Suspense>
  );
};

export default HomePage;
